const LinkedIn = () => {
  return (
    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_46_892)">
        <path
          d="M25.0014 0.71582H1.99336C0.891211 0.71582 0 1.58594 0 2.66172V25.7646C0 26.8404 0.891211 27.7158 1.99336 27.7158H25.0014C26.1035 27.7158 27 26.8404 27 25.7699V2.66172C27 1.58594 26.1035 0.71582 25.0014 0.71582ZM8.01035 23.7238H4.00254V10.8355H8.01035V23.7238ZM6.00645 9.07949C4.71973 9.07949 3.68086 8.04062 3.68086 6.75918C3.68086 5.47773 4.71973 4.43887 6.00645 4.43887C7.28789 4.43887 8.32676 5.47773 8.32676 6.75918C8.32676 8.03535 7.28789 9.07949 6.00645 9.07949ZM23.008 23.7238H19.0055V17.459C19.0055 15.9666 18.9791 14.0418 16.9225 14.0418C14.8395 14.0418 14.523 15.6713 14.523 17.3535V23.7238H10.5258V10.8355H14.3648V12.5969H14.4176C14.9502 11.5844 16.258 10.5139 18.2039 10.5139C22.2592 10.5139 23.008 13.1822 23.008 16.6521V23.7238Z"
          fill="#2F2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_46_892">
          <rect width="27" height="27" fill="white" transform="translate(0 0.71582)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkedIn;
